// extracted by mini-css-extract-plugin
module.exports = {"imgr":"index-module__imgr___On9Db","imr_txt":"index-module__imr_txt___cSFez"};